import { useTranslation } from 'next-i18next'
import { OutlineButton } from './product-clickcollect'
import { AiFillThunderbolt } from 'react-icons/ai'
import OOSIcon from '@components/icons/oos-icon'
import { FC } from 'react'
import { Email } from '@contexts/checkout/checkout.utils'
import { useForm } from 'react-hook-form'
import Input from '@components/ui/form/input'
import pdpService from '@services/pdp-service'
import { useMutation } from 'react-query'
import Button from '@components/ui/button'

const ProductOosSection: FC<{ sku: string }> = ({ sku }) => {
  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
  } = useForm<Email>()
  const { t: translate } = useTranslation(['common', 'forms'])

  const {
    mutate: notifyRequest,
    isLoading,
    isError,
    isSuccess,
    error,
  } = useMutation((email: string) => {
    return pdpService.stockNotifyRequest({
      data: {
        sku: sku,
        email,
      },
    })
  })

  function onSubmit({ email }: Email) {
    // closeModal();
    notifyRequest(email)
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="m-auto my-5" noValidate>
      <OOSIcon className="m-auto" />
      <p className="text-center text-brand-darkred text-sm mt-4">
        {translate('text-currently-out-of-stock', { ns: 'common' })}
      </p>

      {isSuccess ? (
        <p className="px-2 mt-2">
          <span className="text-sm font-medium text-brand-green">
            {translate('text-out-of-stock-email', { ns: 'common' })}
          </span>
        </p>
      ) : (
        <>
          <Input
            type="email"
            placeholder="Email Address"
            variant="simple"
            {...register('email', {
              required: `${translate('email-required', { ns: 'forms' })}`,
              pattern: {
                value:
                  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                message: translate('email-error', { ns: 'forms' }),
              },
            })}
            error={errors.email?.message}
            maxLength={50}
          />
          <div className="flex justify-between items-center mt-2">
            <div className="flex-1"></div>{' '}
            <Button
              type="submit"
              loading={isLoading}
              className={`mt-3 sm:mt-0 h-[50px] px-3 text-white ${
                isValid ? 'bg-brand' : 'bg-brand-gray'
              } border-0 whitespace-nowrap`}
              disabled={!isValid}
            >
              {translate('text-notify-me-available', { ns: 'common' })}
            </Button>
          </div>
        </>
      )}
    </form>
  )
}

export default ProductOosSection
